export interface SeriesItem {
  id: string;
  title: string;
  kind: '电视剧';
  year: string;
  genres: string[];
  region: string;
  rating: number;
  episodeInfo: string;
  updateSchedule: string;
  summary: string;
  poster: string;
}

export const hotSeries: SeriesItem[] = [
  {
    id: 'series-01',
    title: '雾都迷案',
    kind: '电视剧',
    year: '2026',
    genres: ['悬疑', '犯罪'],
    region: '中国大陆',
    rating: 8.7,
    episodeInfo: '更新至 24 集 / 共 32 集',
    updateSchedule: '每周一、三、五 20:00 更新',
    summary:
      '雨雾笼罩的江城里，一桩陈年旧案牵出三条彼此纠缠的线索。年轻检察官必须在真相与立场之间做出选择。',
    poster:
      'https://readdy.ai/api/search-image?query=cinematic%20drama%20poster%20illustration%20of%20a%20foggy%20riverside%20city%20with%20layered%20old%20buildings%20and%20warm%20lamp%20glow%2C%20amber%20and%20deep%20maroon%20palette%2C%20moody%20atmosphere%2C%20minimal%20elegant%20composition%2C%20high%20detail&width=400&height=600&seq=xc-series-01&orientation=portrait',
  },
  {
    id: 'series-02',
    title: '远山有灯',
    kind: '电视剧',
    year: '2025',
    genres: ['年代', '剧情'],
    region: '中国大陆',
    rating: 9.0,
    episodeInfo: '更新至 36 集 / 共 40 集',
    updateSchedule: '每晚 19:30 更新 2 集',
    summary:
      '从山脚小镇到远方城市，一家三代人用四十年的时间，把一盏灯从煤油换成了电灯，也把生活换成了另一种模样。',
    poster:
      'https://readdy.ai/api/search-image?query=cinematic%20period%20drama%20poster%20illustration%20of%20a%20warm%20mountain%20village%20at%20dusk%20with%20single%20glowing%20window%20lights%2C%20amber%20gold%20and%20rust%20tones%2C%20nostalgic%20soft%20light%2C%20minimal%20composition%2C%20high%20detail&width=400&height=600&seq=xc-series-02&orientation=portrait',
  },
  {
    id: 'series-03',
    title: '第九空间',
    kind: '电视剧',
    year: '2026',
    genres: ['科幻', '悬疑'],
    region: '中国大陆',
    rating: 8.4,
    episodeInfo: '更新至 16 集 / 共 24 集',
    updateSchedule: '每周六 21:00 更新 4 集',
    summary:
      '一群互不相识的人同时被困在一间不断变形的公寓里。他们发现，走出去的条件是有人愿意留下。',
    poster:
      'https://readdy.ai/api/search-image?query=cinematic%20sci%20fi%20poster%20illustration%20of%20an%20impossible%20shifting%20apartment%20interior%20with%20glowing%20doorways%2C%20warm%20amber%20light%20against%20deep%20crimson%20shadow%2C%20surreal%20minimal%20composition%2C%20high%20detail&width=400&height=600&seq=xc-series-03&orientation=portrait',
  },
  {
    id: 'series-04',
    title: '厨房里的人生',
    kind: '电视剧',
    year: '2025',
    genres: ['剧情', '美食'],
    region: '中国大陆',
    rating: 8.6,
    episodeInfo: '更新至 30 集 / 共 30 集',
    updateSchedule: '已完结，可全集观看',
    summary:
      '一间开在巷口的小饭馆，收留过深夜加班的上班族，也招待过迷路的旅人。每道菜背后，都有一个没说完的故事。',
    poster:
      'https://readdy.ai/api/search-image?query=cinematic%20warm%20poster%20illustration%20of%20a%20cozy%20small%20kitchen%20with%20steaming%20dishes%20and%20hanging%20pans%2C%20amber%20and%20honey%20tones%2C%20inviting%20soft%20light%2C%20minimal%20elegant%20composition%2C%20high%20detail&width=400&height=600&seq=xc-series-04&orientation=portrait',
  },
  {
    id: 'series-05',
    title: '青川志异',
    kind: '电视剧',
    year: '2026',
    genres: ['古装', '奇幻'],
    region: '中国大陆',
    rating: 8.8,
    episodeInfo: '更新至 40 集 / 共 48 集',
    updateSchedule: '每周二、四、日 20:00 更新',
    summary:
      '一个能看见“异闻”的书生，被卷入青川城里接连发生的怪事。他逐渐发现，志怪录里的故事都指向同一段被抹去的历史。',
    poster:
      'https://readdy.ai/api/search-image?query=cinematic%20ancient%20fantasy%20poster%20illustration%20of%20a%20scholar%20with%20lantern%20before%20a%20moonlit%20temple%2C%20amber%20gold%20and%20deep%20crimson%20palette%2C%20mystical%20glow%2C%20ornate%20minimal%20composition%2C%20high%20detail&width=400&height=600&seq=xc-series-05&orientation=portrait',
  },
  {
    id: 'series-06',
    title: '归途列车',
    kind: '电视剧',
    year: '2025',
    genres: ['都市', '剧情'],
    region: '中国大陆',
    rating: 8.1,
    episodeInfo: '更新至 22 集 / 共 30 集',
    updateSchedule: '每周五 21:00 更新 2 集',
    summary:
      '一列横跨南北的绿皮火车上，六位乘客的目的地各不相同。旅途越长，他们越像在重走各自的人生。',
    poster:
      'https://readdy.ai/api/search-image?query=cinematic%20poster%20illustration%20of%20a%20green%20train%20traveling%20across%20golden%20fields%20at%20sunset%20seen%20from%20above%2C%20amber%20and%20rust%20tones%2C%20warm%20nostalgic%20light%2C%20minimal%20clean%20composition%2C%20high%20detail&width=400&height=600&seq=xc-series-06&orientation=portrait',
  },
];